import BaseApi from './baseApi';
import IInboundDocument from '../models/IInboundDocument';
import IAuthentication from '../models/IAuthentication';
export default class InboundDocumentApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundDocuments(idInbound: string) : Promise<IInboundDocument[]> {
        let json : string = this.getJsonRead(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundDocuments: IInboundDocument[] = [];
            inboundDocuments = response.data as IInboundDocument[];
            return inboundDocuments;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundDocument(inboundDocument: IInboundDocument) : Promise<string> {
        const json = this.getJsonSave(inboundDocument);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundDocument(inboundDocument: IInboundDocument) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundDocument);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDocument(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundDocumentByInboundId(inboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundId(inboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByInboundId(inboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDocuments",
            "conditions": [{
                "Item1": "InboundsDocuments",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": inboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDocuments",
            "conditions": [{
                "Item1": "InboundsDocuments",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundDocument: IInboundDocument) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idListCustomPaper",
                "Item2": inboundDocument.idListCustomPaper
            }, {
                "Item1": "description",
                "Item2": inboundDocument.description
            }, {
                "Item1": "URL",
                "Item2": inboundDocument.url
            }, {
                "Item1": "idCompany",
                "Item2": inboundDocument.idCompany
            }, {
                "Item1": "idInbound",
                "Item2": inboundDocument.idInbound
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDocuments"
        };
        return json;
    }

    private getJsonUpdate(inboundDocument: IInboundDocument) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idListCustomPaper",
                "Item2": inboundDocument.idListCustomPaper
            }, {
                "Item1": "description",
                "Item2": inboundDocument.description
            }, {
                "Item1": "URL",
                "Item2": inboundDocument.url
            }, {
                "Item1": "idCompany",
                "Item2": inboundDocument.idCompany
            }, {
                "Item1": "idInbound",
                "Item2": inboundDocument.idInbound
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsDocuments",
            "keyvalue": inboundDocument.id
        };
        return json;
    }

    private getJsonRead(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsDocuments",
                "Item2": "id"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "idListCustomPaper"
            }, {
                "Item1": "ListCustomPapers",
                "Item2": "name as custompapername"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "description"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "url"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "InboundsDocuments"
            }, {
                "Item1": "ListCustomPapers"
            }],
            "joins": [{
                "Item1": "InboundsDocuments",
                "Item2": "idListCustomPaper",
                "Item3": "ListCustomPapers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsDocuments",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsDocuments",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": idInbound
            }]
        };
        return json;
    }
}
